import { render, staticRenderFns } from "./courseManagement.vue?vue&type=template&id=42cb0eaa&"
import script from "./courseManagement.vue?vue&type=script&lang=js&"
export * from "./courseManagement.vue?vue&type=script&lang=js&"
import style0 from "./courseManagement.vue?vue&type=style&index=0&id=42cb0eaa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports